import React, { CSSProperties } from 'react';
import classes from './OverviewCard.module.css';
import { LineItem, WidgetComponent } from '~/types/layout';
import { useHistory } from 'react-router-dom';

import { ReactComponent as ExternalLink } from '~/utils/images/external.svg';
import { ReactComponent as ViewAllTexts } from '~/utils/images/eye.svg';


type OverviewCardProps = WidgetComponent<{
  content: {
    lineItems: LineItem[];
  };
  style: CSSProperties;
  count: number;
  externalIcon: string;
  internalIcon: string;
  internalPath: string;
  action: {
    type: string;
    path: string;
  };
}> & {};

export const OverviewCard = (props: OverviewCardProps) => {
  const { data, action } = props;
  const history = useHistory();

  const onComponentClicked = () => {
    if (action?.type === 'navigate' && action?.path) {
      history.push(action?.path);
    }

    if (action?.type === 'external' && action?.path) {
      window.open(action?.path, '_blank')
    }
  };

  const onComponentInternalClicked = () => {
    data.internalPath && history.push(data.internalPath);
  };

  

  return (
    <div
      className={classes.wrapper}
      style={data.style}
      onClick={data.externalIcon ? undefined : onComponentClicked}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <p className='margin-right-16'>
          {data?.content?.lineItems?.map((lineItem) => (
            <div style={lineItem.style}>{lineItem.text}</div>
          ))}
        </p>
        <span style={{ fontSize: '24px', fontWeight: 'bold' }}>
          {data.count}
        </span>
        {data.externalIcon && (
          <>
        <div className={classes.extradetails}>
          <div onClick={onComponentClicked} style={{ display: 'flex', justifyContent: 'center' }}>
            <ExternalLink />
          </div>
          <div>
            <i>unread</i>
          </div>
        </div>
      
        <div className={classes.extradetails}>
          <div onClick={onComponentInternalClicked} style={{ display: 'flex', justifyContent: 'center' }}>
            <ViewAllTexts />
          </div>
          <div>
            <i>view all</i>
          </div>
        </div>
        </>
      )}
      </div>
    </div>

  );
};
